import styled from 'styled-components';

const FileUpload = styled.input`
    display: none;
`;

export default FileUpload;